import ReactPlayer from "react-player";
import brandVideo from "../../assets/video/landingPage.mp4";
import brandLogo from "../../assets/images/brandLogo.png";
// import brandLogoLight from "../../assets/images/D-Light.png";

import styles from "./index.module.scss";
import { useContext, useEffect, useRef, useState } from "react";
import JoinModal from "./partials/JoinModal/JoinModal";
import SpeakersCards from "../../components/VideoDetails/partials/SpeakersCards";
import {
  AnimatedHeader,
  ContactFooter,
  MuxVideoPlayer,
} from "../../components";
import ourExpert from "../../assets/images/ourExpert.png";
import landingPageBg from "../../assets/images/landingPageBg.jpg";
import landingPageBgMobile from "../../assets/images/landingPageBgMobile.jpg";
import firebase, { firestore } from "../../firebase/firebase";
import { SourceType } from "../../AppConstants/TypeConstants";
import { isMobileDevice } from "../../utils/getPlatformInfo";
import Lottie from "react-lottie-player";
import ScrollLottie from "../../assets/lotties/ScrollLottie.json";
import { AnalyticsContext } from "../../contexts/Analytics/AnalyticsContextProvider";
import AboutCard from "./partials/AboutCard/AboutCard";
import ComingSoonSection from "./partials/ComingSoonSection";

import { authContext } from "../../contexts/AuthContext/AuthContextProvider";
import OTPForm from "../../components/Signup/partials/OTPForm/OTPForm";
import Login from "../../components/Login/Login";
import { BrandName } from "../../components/NavHeader";
const uniqid = require("uniqid");
//  https://stream.mux.com/7olp88yqkixU6xmbZdlrfqI8VbalquQjPDS01sYfUFOY.m3u8
//  https://stream.mux.com/xPH2J8eM00lZj01Ui9AwgVbchAwRNN00vf01YckqiEoZC3Y/high.mp4

const addSPeakers = () => {
  const serverTimeStamp = firebase.firestore.Timestamp.now();
  const obj = {
    data: [
      {
        id: uniqid("speaker-"),
        degree: "",
        designation:
          "Dr. Mehrotra is one of the finest  specialist in Cardiac Sciences with a rich experience of over 21 years. He has handled numerous complex medical cases and is known for attention to detail, accurate diagnosis and treating patients with empathy.",
        name: "Dr. Rahul Mehrotra",
        photoUrl:
          "https://storage.googleapis.com/docflix-d8cab.appspot.com/landingPage/speakers/Rahul%20mehrotra.png",
        profileLine:
          "Director and Head, NonInvasive Cardiology at Max Supersperspeciality Hospital",
        therapy: "",
        timestamp: serverTimeStamp,
      },
      {
        id: uniqid("speaker-"),
        degree: "",
        designation:
          "He has special interests in Complex Coronary Interventions, Peripheral Interventions, Carotid Angioplasty, Endovascular Aortic Aneurysm Repair, Cardiac Resynchronisation Therapy",
        name: "(Dr) Col Anil Dhall Sena Medal",
        photoUrl:
          "https://storage.googleapis.com/docflix-d8cab.appspot.com/landingPage/speakers/Anil%20dhall.png",
        profileLine:
          "Professor Cardiology, Janakpuri Super Speciality Hospital",
        therapy:
          "Dr. Dhall is a Fellow of American College of Cardiology, European Society of Cardiology, Society for Cardiovascular Angiography and Interventions, Heart Rhythm Society and Cardiological Society of India.",
        timestamp: serverTimeStamp,
      },
      {
        id: uniqid("speaker-"),
        degree: "",
        designation:
          "Dr. Kalra is the President elect for South Asian Federation of Endocrine Societies and immediate Past President for Endocrine Society of India.He serves as Associate Editor, Diabetic Medicine (UK), while offering his editorial skills to various other publications. He is an international lecturer and author of numerous published peer-reviewed research papers and an active peer reviewer.",
        name: "Dr Sanjay Kalra",
        photoUrl:
          "https://storage.googleapis.com/docflix-d8cab.appspot.com/landingPage/speakers/Sanjay%20kalra.png",
        profileLine: "Consultant Endocrinologist, Bharti Hospital",
        therapy: "",
        timestamp: serverTimeStamp,
      },
      {
        id: uniqid("speaker-"),
        degree: "",
        designation:
          "Prof. Sethi has been President of Cardiology Society of India and Member of Executive Council of Asia Pacific Society of Cardiology. He has been the editor of Indian Heart Journal, and is a member of the editorial board of Journal of Invasive Cardiac Electrophysiology. He has been awarded several national awards and orations.",
        name: "Dr. (Prof) Kamal K. Sethi",
        photoUrl:
          "https://storage.googleapis.com/docflix-d8cab.appspot.com/landingPage/speakers/K%20K%20SETHI.png",
        profileLine:
          "Chairman & Head, Cardiology, Delhi Heart & Lung Institute",
        therapy: "",
        timestamp: serverTimeStamp,
      },

      {
        id: uniqid("speaker-"),
        degree: "",
        designation:
          "Dr. Sawhney is also Chief for Clinical and Preventive Cardiology, and member board of management at Sir Ganga Ram Hospital.He is a fellow of American College of Cardiology (FACC), European society of cardiology (FESC) and member of American Heart association, European society of Heart failure and European Society of Preventive cardiology.Dr JPS Sawhney known for his contribution in Research filed in India.He is pioneer in field of research work in Private Setup Hospital.",
        name: "Dr J P S Sawhney",
        photoUrl:
          "https://storage.googleapis.com/docflix-d8cab.appspot.com/landingPage/speakers/J%20P%20SAWHNEY.png",
        profileLine:
          "Senior Consultant and Chairman,  Department of Cardiology Sir Ganga Ram Hospital",
        therapy: "",
        timestamp: serverTimeStamp,
      },
      {
        id: uniqid("speaker-"),
        degree: "",
        designation:
          "Dr Mithal is the first Indian to serve on international bodies like the WHO Global Task force on Osteoporosis and Committee of Scientific Advisors, Asia Pacific Advisory Council and Board of Governance of the International Osteoporosis Foundation. In addition Dr Mithal has been President of the Endocrine Society of India, Indian Society for Bone and Mineral Research (ISBMR), and Bone and Joint Decade.",
        name: "Dr Ambrish Mithal",
        photoUrl:
          "https://storage.googleapis.com/docflix-d8cab.appspot.com/landingPage/speakers/Ambrish.png",
        profileLine:
          "Chairman and Head - Endocrinology and Metabolism, Max Healthcare",
        therapy: "",
        timestamp: serverTimeStamp,
      },
      {
        id: uniqid("speaker-"),
        degree: "",
        designation:
          "Dr. Kaul is the current Co- Chairman of the Credentials Committee of the SCAI, USA and Course director of Asia PCR/Sing live and India Live. He is also Editor in Chief of the Journal ASIA Interventions and Fortis Medical Journal.Among the numerous recognitions he has, he has also been awarded the coveted Dr B C Roy Award and Padamshri from the President of India .",
        name: "Dr (Prof.)Upendra Kaul",
        photoUrl:
          "https://storage.googleapis.com/docflix-d8cab.appspot.com/landingPage/speakers/Upendra%20kaul.png",
        profileLine: "Chairman, Batra Heart Centre, BHMRC",
        therapy: "",
        timestamp: serverTimeStamp,
      },
      {
        id: uniqid("speaker-"),
        degree: "",
        designation:
          "Dr. A.K. Kriplani, is a nationally recognized leader in the field of laparoscopic gastrointestinal and bariatric surgery. Dr. Kriplani is the “Past President” of the Indian Association of Gastrointestinal Endosurgeons. Fellowship programs of the IAGES introduced by him have been very popular and widely acclaimed. He has the credit of being first in India to perform laparoscopic adrenalectomy and laparoscopic splenectomy",
        name: "Dr Ajay Kumar Kriplani",
        photoUrl:
          "https://storage.googleapis.com/docflix-d8cab.appspot.com/landingPage/speakers/AJAY%20KRIPLANI.png",
        profileLine:
          "Director and Head, NonInvasive Cardiology at Max Supersperspeciality Hospital, Saket",
        therapy: "",
        timestamp: serverTimeStamp,
      },
      {
        id: uniqid("speaker-"),
        degree: "",
        designation: "M.D.,FACC.,FAHA.,FESC.,FSCCT.,FRCP.,FICC.,FCSI",
        name: "Dr Uday Jadhav",
        photoUrl:
          "https://storage.googleapis.com/docflix-d8cab.appspot.com/landingPage/speakers/Uday%20Jadav.png",
        profileLine:
          "Cardiology and Cardiac CT Department MGM New Bombay Hospital",
        therapy: "",
        timestamp: serverTimeStamp,
      },
      {
        id: uniqid("speaker-"),
        degree: "",
        designation:
          "Dr. Karnik has served at a wide range of hospitals, including as visiting clinician at Mayo Clinic in Rochester, USA, and as Honorary Registrar at Freeman Hospital, University of Newcastle-upon-Tyne, UK.His special interest is in Coronary interventions, pacemaker & implantable defibrillator (ICD) device implantations as well as academic and clinical cardiology. He was working on the project of Telemedicine assisted by Arthur Anderson Co, during which he was awarded Rashtriya Ratna award in 1992.",
        name: "Dr Rajiv Karnik",
        photoUrl:
          "https://storage.googleapis.com/docflix-d8cab.appspot.com/landingPage/speakers/Rajiv%20karnik.png",
        profileLine:
          "Director, Heart Failure Clinic and Interventional Cardiologist, Fortis Hospitals",
        therapy: "",
        timestamp: serverTimeStamp,
      },
      {
        id: uniqid("speaker-"),
        degree: "",
        designation:
          "Over the years, he has taken pioneering efforts in the field of Medico-legal publications. He has been an editor for many specialty Medico-legal journals (Doctor in the Court, Medico-Legal Reporter, etc). He is frequently invited for orations, lectures, seminars etc. on medico-legal issues. In association with pharma companies he has published many books on the topic of Consumer protection Act & Doctors which is a burning issue in today’s times. The case study pattern of their publications is a big hit amongst doctors all over the country",
        name: "Dr Kunal Sethi",
        photoUrl:
          "https://storage.googleapis.com/docflix-d8cab.appspot.com/landingPage/speakers/Kunal%20Sethi.png",
        profileLine: "DIRECTOR MEDICO-LEGAL PUBLISHER",
        therapy: "",
        timestamp: serverTimeStamp,
      },

      {
        id: uniqid("speaker-"),
        degree: "",
        designation:
          "Dr Subhash Kaul is highly skilled and experienced in treating major and minor neurology diseases. Some of the best treatments provided by the doctor are neurology diseases treatment, back and neck pain treatment, brain hemorrhage treatment, neck pain treatment, paralysis recovery treatment, head infection treatment etc.",
        name: "Dr Subhash Kaul",
        photoUrl:
          "https://storage.googleapis.com/docflix-d8cab.appspot.com/landingPage/speakers/Subhash%20kaul.png",
        profileLine:
          "Consultant & Associate Professor, Department of Neurology, KIMS Hospital",
        therapy: "",
        timestamp: serverTimeStamp,
      },
    ],
  };
  const docRef = firestore.collection("landingPage").doc("speakers");
  docRef.set(obj);
};

const LandingPage = () => {
  const { addGAWithNoUser } = useContext(AnalyticsContext);
  const { toggleSignInbtn, state } = useContext(authContext);
  const { showOTPModal, showSignInModal, showJoinModal } = state;

  const muxVideoRef = useRef("");

  const [videoReady, setVideoReady] = useState(isMobileDevice ? true : false);
  const [videoData, setVideoData] = useState(null);
  sessionStorage.removeItem("exclusiveSeason");

  const handleJoinModalOpen = () => {
    addGAWithNoUser("join_the_waitlist_btn");
    toggleSignInbtn("showSignInModal", true);
  };

  const [speakers, setSpeakers] = useState([]);
  useEffect(() => {
    getSpeakers();
    getVideosData();
    // uncomment to add speakers data
    // addSPeakers();
  }, []);

  const getSpeakers = async () => {
    try {
      const ref = firestore.collection("landingPage").doc("speakers");
      let res = await ref.get();

      if (!res.exists) {
        setSpeakers([]);
        return;
      }
      let _data = res.data().data;
      let sortedArray = sortAscending(_data);
      setSpeakers(sortedArray);
    } catch (error) {
      console.error(error);
    }
  };
  const sortAscending = (array) => {
    return array.sort((a, b) => a.order - b.order);
  };
  const getVideosData = async () => {
    try {
      const ref = firestore.collection("landingPage").doc("video");
      let res = await ref.get();

      if (!res.exists) {
        setVideoData(null);
        return;
      }
      let _data = res.data();
      setVideoData(_data);
    } catch (error) {
      console.error(error);
    }
  };

  const closeStartWatchingBtn = () => {};

  const videoContainerHeight = videoReady ? "100%" : "100vh";
  const videoContainerWidth = videoReady ? "100%" : "100vw";

  return (
    <>
      <div className={styles.mainContainer}>
        <div
          className={styles.container}
          style={{
            background: !isMobileDevice
              ? `url(${isMobileDevice ? landingPageBgMobile : landingPageBg})`
              : "",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            height:
              videoData && videoData.sourceType === "mp4"
                ? videoContainerHeight
                : "",
            width:
              videoData && videoData.sourceType === "mp4"
                ? videoContainerWidth
                : "",
            paddingTop:
              videoData && isMobileDevice && videoData.sourceType === "mp4"
                ? "5rem"
                : "",
          }}
        >
          {videoData && videoData.sourceType === "mp4" && (
            <ReactPlayer
              playing={true}
              url={
                isMobileDevice ? videoData.mobileVideo : videoData.deskTopVideo
              }
              playsinline={true}
              muted
              autoPlay
              onReady={() => !isMobileDevice && setVideoReady(true)}
              height="100%"
              width="100%"
              controls={false}
              loop={true}
            />
          )}
          <Lottie
            loop
            animationData={ScrollLottie}
            play
            className={`${styles["scroll-down"]}`}
            onClick={() => {
              var element = document.getElementById("content");
              element.scrollIntoView({
                behavior: "smooth",
                block: "start",
                inline: "nearest",
              });
            }}
          />
          {/* <div
            className={`${styles["scroll-down"]} ${styles["scroll-down-mobile"]}`}
            onClick={() => {
              var element = document.getElementById("content");
              element.scrollIntoView({
                behavior: "smooth",
                block: "start",
                inline: "nearest",
              });
            }}
          >
            Our Experts
          </div> */}
          {videoData && videoData.sourceType === SourceType.SOURCE_MUX && (
            <MuxVideoPlayer
              showPlayer={true}
              isSidePanelOpen={false}
              closeStartWatchingBtn={closeStartWatchingBtn}
              videoData={
                isMobileDevice
                  ? {
                      playbackid: videoData.mobilePlaybackId,
                      title: videoData.title,
                    }
                  : {
                      playbackid: videoData.desktopPlaybackId,
                      title: videoData.title,
                    }
              }
              muxVideoRef={muxVideoRef}
              themeType={"OTHER"}
            />
          )}
          <div
            className={styles.containerOverlay}
            style={{
              width: videoData && videoData.sourceType === "mp4" ? "100%" : "",
            }}
          >
            <div className={styles.brandLogo}>
              {/* <img src={brandLogo} alt="Docflix" />
              <span>Docflix</span> */}
              <BrandName />
            </div>
            <div className={styles.detail}>
              <div className={styles.mainTitle}>OTT for doctors where</div>
              <div className={styles.heading}>Art meets Science!</div>
              <div className={styles.carouselContent}>
                A new age OTT platform with a wide range of scientific content
                tailored for your various practice needs.
              </div>
              <button className={`btn`} onClick={handleJoinModalOpen}>
                ENTER NOW
              </button>
            </div>
          </div>
        </div>
        <div className={styles.content}>
          <div className={`${styles.detail} ${styles.detailMobile}`}>
            <div className={styles.mainTitle}>OTT for doctors where</div>
            <div className={styles.heading}>Art meets Science!</div>
            <div className={styles.carouselContent}>
              A new age OTT platform with a wide range of scientific content
              tailored for your various practice needs.
            </div>
            <button className={`btn`} onClick={handleJoinModalOpen}>
              ENTER NOW
            </button>
          </div>
          {/* Carousel section start */}
          <div className={`${styles.contentHeading} ${styles.contentHeading1}`}>
            <h2>Watch now, Only on Docflix</h2>
            <ComingSoonSection />
          </div>
          {/* Carousel section start */}
          {/* Speaker section start */}
          <div className={styles.contentHeading} id="content">
            <h2>Our Experts</h2>
            <AnimatedHeader
              imageHeader={ourExpert}
              // mainHeader="Our Expert"
              offset={820}
            />
          </div>
          <SpeakersCards speakersList={speakers} />
          {/* Speaker section end */}
          {/* About section start */}
          <div className={`${styles.contentHeading} ${styles.contentHeading1}`}>
            <h2>
              Why <span>Docflix</span>?
            </h2>
            <div className={styles.subHeading}>
              <span>Docflix</span> is based on 3 strong pillars, most important
              for scientific content:
            </div>
            <AboutCard />
          </div>
          {/* About section end */}
        </div>
        <div className={`${styles.sectionWrapper} ${styles.footerWrapper}`}>
          <ContactFooter zIndexZero />
        </div>
      </div>
      {/* <div
        className={`${styles["scroll-down"]} ${styles["scroll-down-desktop"]}`}
        onClick={() => {
          var element = document.getElementById("content");
          element.scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest",
          });
        }}
      >
        Our Experts
      </div> */}

      {showJoinModal && <JoinModal />}
      {showSignInModal && <Login />}
      {/* {showOTPModal && (
        <div className={`modalOverlayWithBlur ${styles["OTPContainer"]}`}>
          <div className={styles.box}>
            <OTPForm />
          </div>
        </div>
      )} */}
    </>
  );
};

export default LandingPage;
